import React from 'react';
import { Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { getStatusMeta, getStatusLabel } from './statusMeta';

interface StatusChipProps {
  status: string;
  size?: 'small' | 'medium';
}

// Colour-coded status pill used across the redesigned reservations dashboard.
const StatusChip: React.FC<StatusChipProps> = ({ status, size = 'small' }) => {
  const { t } = useTranslation();
  const meta = getStatusMeta(status);

  return (
    <Chip
      label={getStatusLabel(status, t)}
      size={size}
      sx={{
        backgroundColor: meta.bg,
        color: meta.color,
        fontWeight: 700,
        fontSize: 11,
        height: 22,
        borderRadius: '999px',
        '& .MuiChip-label': { px: 1.1 },
      }}
    />
  );
};

export default StatusChip;
